import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LogInModal from 'flarum/forum/components/LogInModal';
import Link from 'flarum/common/components/Link';

/**
 * «Regístrate» deja de abrir el modal y pasa a llevar a `/registro`.
 *
 * Es la mitad visible de la decision de producto del 2026-08-05: UN solo camino de alta.
 * Mientras el boton del header abriera el `SignUpModal`, seguirian existiendo dos altas —
 * una corta que deja el perfil vacio y otra completa— y el modal, por ser el mas visible,
 * ganaria siempre.
 *
 * Se tocan las DOS entradas al modal:
 *   (a) el boton del header (`HeaderSecondary.items`, clave `signUp`);
 *   (b) el enlace «regístrate» del pie del modal de inicio de sesion, que es la otra puerta
 *       real y la que se olvida.
 * El `SignUpModal` en si se deja intacto: sigue siendo montable (otras extensiones lo
 * invocan) y no se rompe nada; simplemente ya no hay nada del producto que apunte a el.
 *
 * `window.__cmRegisterPath` es el puente hacia el HTML de la landing, que vive en
 * `custom_header` FUERA de la aplicacion y por tanto no puede importar nada de aqui. Al
 * verlo definido, sus CTAs navegan a /registro y ademas dejan de inyectar el aviso «despues
 * te pedimos 6 datos», que con el alta unificada seria falso.
 */
export default function addRegisterLink() {
  /**
   * La ruta se resuelve EN CADA USO, nunca en el initializer.
   *
   * `Application.route()` calcula el prefijo asi:
   * `m.route.prefix === '' ? this.forum.attribute('basePath') : ''`. Los initializers corren
   * antes de `mount()` (core `Application.boot()`), cuando `app.forum` todavia no esta
   * asignado y `m.route.prefix` sigue valiendo el `'#!'` por defecto de Mithril. Llamarla
   * ahi devuelve la ruta SIN el basePath — un 404 en cualquier foro instalado en un
   * subdirectorio — y solo no revienta porque ese ternario cortocircuita antes de tocar
   * `app.forum`. Todos los puntos de abajo se ejecutan despues del montaje.
   */
  const registerPath = () => app.route('umbral-comunidad.registro');

  extend(HeaderSecondary.prototype, 'items', function (items: any) {
    const path = registerPath();

    // Se publica ANTES del guard: el puente hacia la landing tiene que existir tambien para
    // quien ya tiene sesion (el header no trae `signUp` entonces), y el header se rinde
    // siempre, en cada carga, ya montado.
    window.__cmRegisterPath = path;

    if (!items.has('signUp')) return;

    // `replace` conserva la prioridad original, asi que el orden del header no se mueve. Se
    // mantienen las clases `Button Button--link` porque de ellas cuelga el pintado teal del
    // tema (`less/forum.less` §3) y el `li.item-signUp` que las specs usan de ancla.
    items.replace(
      'signUp',
      <Link className="Button Button--link" href={path} data-cm-register="1">
        {app.translator.trans('core.forum.header.sign_up_link')}
      </Link>
    );
  });

  override(LogInModal.prototype, 'signUp', function (this: any) {
    this.hide();
    m.route.set(registerPath());
  });
}
